import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "akatemia-app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryList = _resolveComponent("CategoryList")!
  const _component_HakoStickySidePanel = _resolveComponent("HakoStickySidePanel")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_HakoAlertVueManager = _resolveComponent("HakoAlertVueManager")!
  const _component_HakoNotificationVueManager = _resolveComponent("HakoNotificationVueManager")!
  const _component_HakoWindowVueManager = _resolveComponent("HakoWindowVueManager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HakoStickySidePanel, {
      modelValue: _ctx.openSidePanel,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.openSidePanel) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CategoryList, {
          onCategories: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCategories($event))),
          onTogglePanel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleOnMobile())),
          onLogoutemit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout()))
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath,
      onTogglePanel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openSidePanel = !_ctx.openSidePanel))
    })),
    _createVNode(_component_HakoAlertVueManager),
    _createVNode(_component_HakoNotificationVueManager),
    _createVNode(_component_HakoWindowVueManager)
  ]))
}